import { Box } from "@mui/material";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import CallIcon from '@mui/icons-material/Call';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';

import useDisplayDate from "../../hooks/Date/useDisplayDate";


const useApprovalColumns = () => {
  const { formatDate } = useDisplayDate();

  return [
    { accessorKey: 'approvalID', header: 'Approval ID',},
      { accessorKey: 'customerID', header: 'Customer ID',size: 200,},
      { accessorKey: 'leadID', header: 'Lead Id' },
      { accessorKey: 'loanType', header: 'Loan Type'},
      { accessorKey: 'productType', header: 'Product Type',size: 200 },
      { accessorKey: 'branch', header: 'Branch',},
      { accessorKey: 'loanAmtApproved', header: 'Loan Amount Approved',size: 260,
        accessorFn: (row) => {
            const value = row.loanAmtApproved;
            const isNumeric = !isNaN(value) && value !== null && value !== '';
            return(
              <Box display="flex" alignItems="center">
                        {isNumeric && <CurrencyRupeeIcon color="secondary" />}
                        {value}
              </Box>
            )
            
        }
      },
      { accessorKey: 'tenure', header: 'Tenure' },
      { accessorKey: 'roi', header: 'Roi' },
      { accessorKey: 'repayDate', header: 'Repay Date',accessorFn: row => formatDate(row.repayDate) },
      { accessorKey: 'adminFee', header: 'Admin Fee', 
        accessorFn: (row) => {
            const value = row.adminFee;
            const isNumeric = !isNaN(value) && value !== null && value !== '';
            return(
              <Box display="flex" alignItems="center">
                        {isNumeric && <CurrencyRupeeIcon color="secondary" />}
                        {value}
              </Box>
            )
            
        }
      },
      { accessorKey: 'plateFormFee', header: 'PlateForm Fee',
        accessorFn: (row) => {
            const value = row.plateFormFee;
            const isNumeric = !isNaN(value) && value !== null && value !== '';
            return(
              <Box display="flex" alignItems="center">
                        {isNumeric && <CurrencyRupeeIcon color="secondary" />}
                        {value}
              </Box>
            )
            
        },
        size: 200,
      },
      { accessorKey: 'convinineceFee', header: 'Convininece Fee',
        accessorFn: (row) => {
            const value = row.convinineceFee;
            const isNumeric = !isNaN(value) && value !== null && value !== '';
            return(
              <Box display="flex" alignItems="center">
                        {isNumeric && <CurrencyRupeeIcon color="secondary" />}
                        {value}
              </Box>
            )
            
        },
        size: 210,
       },
      { accessorKey: 'creditRiskAnalisys', header: 'Credit Risk Analisys',size: 250 },
      { accessorKey: 'GstOfAdminFee', header: 'Gst Of Admin Fee',size: 220,
        accessorFn: (row) => {
            const value = row.GstOfAdminFee;
            const isNumeric = !isNaN(value) && value !== null && value !== '';
            return(
              <Box display="flex" alignItems="center">
                        {isNumeric && <CurrencyRupeeIcon color="secondary" />}
                        {value}
              </Box>
            )
            
        }
       },
       { accessorKey: 'alternateMobile', header: 'Alternate Mobile',size: 210,
        accessorFn: (row) => (
            <Box display="flex" alignItems="center">
              {row.alternateMobile && <CallIcon color="primary"/>}
               <a href={`tel:${row.alternateMobile}`} style={{ textDecoration: 'underline', color: 'inherit' }}>
                     {row.alternateMobile}
                </a>
            </Box>
        )
        },
       { accessorKey: 'officialEmail', header: 'Official Email',size: 250,
        accessorFn: (row) => (
            <Box display="flex" alignItems="center">
              {row.officialEmail && <AlternateEmailIcon color="primary"/>}
               <a href={`mailto:${row.officialEmail}`} style={{ textDecoration: 'underline', color: 'inherit' }}>
                     {row.officialEmail}
                </a>
            </Box>
        )
        },
       { accessorKey: 'monthlyIncome', header: 'Monthly Income',size: 220,
        accessorFn: (row) => {
            const value = row.monthlyIncome;
            const isNumeric = !isNaN(value) && value !== null && value !== '';
            return(
              <Box display="flex" alignItems="center">
                        {isNumeric && <CurrencyRupeeIcon color="secondary" />}
                        {value}
              </Box>
            )
            
        }
       },
       { accessorKey: 'cibil', header: 'Cibil' },
       { accessorKey: 'activeLoans', header: 'Active Loans',size: 200 },
       { accessorKey: 'activePL', header: 'Active PL' },
       { accessorKey: 'activeHL', header: 'Active HL' },
       { accessorKey: 'activeCC', header: 'Active CC' },
      { accessorKey: 'activePaydayLoan', header: 'Active Payday Loan',size: 250 },

      { accessorKey: 'outstandingAmount', header: 'Outstanding Amount',size: 250 },
      { accessorKey: 'monthlyObligation', header: 'Monthly Obligation',size: 250 },
      { accessorKey: 'status', header: 'Status' },
      { accessorKey: 'remark', header: 'Remark' },
      { accessorKey: 'loanRequirePurpose', header: 'Loan Require Purpose',size: 260 },
      { accessorKey: 'creditedByName', header: 'Credited By Name',size: 230 },
      { accessorKey: 'creditedByRole', header: 'Credited By Role',size: 230 },
      { accessorKey: 'rejectionReason', header: 'Rejection Reason',size: 230 },
      { accessorKey: 'documentr', header: 'Document R',size: 200 },
      { accessorKey: 'redFlag', header: 'Red Flag' },
      { accessorKey: 'createdDate', header: 'Created Date',accessorFn: row => formatDate(row.repayDate),size: 200 },


  ];
};

export default useApprovalColumns;
